export const Logo = ({ size = 40 }) => (
  <img
    src="/lfcc-crest.png"
    width={size}
    height={size}
    alt="Living Fountain Christian Centre crest"
    className="object-contain shrink-0"
    style={{ width: size, height: size }}
    data-testid="lfcc-logo"
  />
);
